module.exports = __webpack_public_path__ + "static/teddy4-37d8702c8b52edba1d9ad26c5d501e8f.png";